var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFileUploaded = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49998 0H21.6171L31.7499 10.0935V33.75C31.7499 34.9931 30.742 36 29.5 36H2.49998C1.25794 36 0.25 34.9931 0.25 33.75V2.24998C0.25 1.0069 1.25806 0 2.49998 0Z",
    fill: "#5BD5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7174 10.1259H23.875C22.6329 10.1259 21.625 9.11799 21.625 7.87595V0.0234375L31.7174 10.1259Z",
    fill: "#00AAE5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFileUploaded, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file-uploaded.7dda2109.svg";
export { ForwardRef as ReactComponent };